import React from "react";
import PropTypes from "prop-types";
import { getTrueClasses } from "../../../../helpers";
import "./index.scss";

const TITLES = {
  unknown: "Regístrate gratis y obtén:",
  trial: "Consíguelo gratis ahora:",
  paid: "Tu acceso completo incluye:",
};

const ITEMS_LIST = [
  <>
    Prueba ilimitada del kit de <br />
    herramientas para vendedores
  </>,
  <>
    Reportes de productos populares <br />y tendencias de Amazon
  </>,
  <>
    Curso paso a paso "Cómo vender <br />
    en Amazon"
  </>,
];
const STATIC_LIST = ITEMS_LIST.map((text, i) => (
  <div key={text} className={`PgESM-HI-O-item PgESM-HI-O-item_i${i + 1}`}>
    <div className="PgESM-HI-O__num">
      <span>{i + 1}</span>
    </div>
    <p className="PgESM-HI-O__text">{text}</p>
  </div>
));

const Offer = ({ status }) => (
  <div className={getTrueClasses("PgESM-HI-O", `PgESM-HI-O_${status}`)}>
    <p className="PgESM-HI-O__title">{TITLES[status]}</p>
    {STATIC_LIST}
  </div>
);

Offer.propTypes = {
  status: PropTypes.string,
};

export default Offer;
